import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';
import { selectTagSummary } from 'selectors';

import { TagHideButton } from 'Components/Pages/Results/Tags';

class ActiveTagFilter extends Component {
  handleDismiss = () => {
    const { removeTagFilter, tag } = this.props;
    removeTagFilter(tag);
  };

  render() {
    const { tag, count } = this.props;
    return (
      <div className={`ActiveTagFilter ${tag.displayClass}`}>
        <button
          className="ActiveTagFilter-dismiss btn"
          aria-label="Remove filter"
          onClick={this.handleDismiss}
        />
        <h2 className="ActiveTagFilter-name">{tag.name}</h2>
        <div className="ActiveTagFilter-count">
          {count}
          <span className="ActiveTagFilter-count-subtitle"> (in top 100)</span>
        </div>
        <p className="ActiveTagFilter-description">{tag.description}</p>
        <TagHideButton tag={tag} />
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const tagSummary = selectTagSummary(state, props.tag);
  return {
    count: tagSummary.count || 0,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      removeTagFilter: actions.removeTagFilter,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActiveTagFilter);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/ActiveTagFilters/ActiveTagFilter.js